'use client';
import React, { useState, useEffect } from 'react';
import Mydata from '../../data/blog/whyBussiness.json';
import style from '@/app/style/servicesetyle.module.css';
import { FaFacebook, FaInstagram, FaTwitter } from 'react-icons/fa';
import Sticky from './sticky';
import { IoIosArrowDown } from 'react-icons/io';
function hero() {
  const Data = Mydata[0];
  const [isExpanded, setIsExpanded] = useState(true);

  // UseEffect to check screen size on load
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Example breakpoint for mobile view
        setIsExpanded(false);
      } else {
        setIsExpanded(true);
      }
    };

    // Run the function initially
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle function to expand/collapse the content
  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="">
      {/* <div className="bg-[#E9EDFF] mt-2 font-base font-normal px-2 py-1 rounded-md inline-block mb-2">
        {Data.category}
      </div> */}
      {/* <h1 className=" blogMain">{Data.Mainheadig}</h1> */}
      <div
        id={style.blogsiz}
        className={`flex items-end   ${style.blogbussinestravel}`}
      >
        <div className=" opecit w-full ">
          <div
            className=" mb-8 w-full
       mx-auto px-4 max-w-7xl px-3 "
          >
            <p className="bg-[#d5af34] p-2 mb-2 rounded-lg inline-block">
              Black Car Service
            </p>
            <h1 className="serviceh1">
              Why Business Travelers Choose {''}
              <span className="main_color"> Black Car Services in Dallas?</span>
            </h1>
          </div>
        </div>
      </div>
      <div className=" flex   justify-between gap-3 mx-auto max-w-7xl px-4 pt-4">
        <div className="border-1 p-1 px-4 flex items-center  justify-between rounded-lg border-[#2B3252] text-[#2B3252]">
          Est. Reading Time: 9 mins 13 sec
        </div>
        <div>
          <div className="bg-[#2B3252] text-white px-2 p-1 rounded-lg">
            24 Oct 2024
          </div>
        </div>
      </div>

      <div className=" flex justify-end  mx-auto max-w-7xl px-6  ">
        <Sticky className="mt-10" />
      </div>

      <div className="mx-auto max-w-5xl px-4 mt-4">
        <h2
          className="blogtitle "
          onClick={handleToggle}
          style={{ cursor: 'pointer', display: 'inline', alignItems: 'center' }}
        >
          {/* Title text */}
          <span
            className="border-b-2  border-[#2B3252]"
            style={{ flexGrow: 1 }}
          >
            {Data.title}
          </span>

          {/* Arrow icon, rotated based on isExpanded */}
          <span
            className={`arrow  ${isExpanded ? 'rotate' : ''}`}
            style={{
              display: 'inline-block',
              marginLeft: '10px',
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}
          >
            <IoIosArrowDown />
          </span>
        </h2>
        {isExpanded && (
          <ul className="cardbg rounded pl-10 mt-3 pb-2">
            {Data.des.map((point, index) => (
              <li key={index} className="blogcontent list-disc">
                <a
                  href={`#${point.id}`} // Link to the heading ID
                  dangerouslySetInnerHTML={{ __html: point.title }} // Render title
                  className="animated-link"
                ></a>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default hero;
